import { createReducer } from '../../utils/redux';
import * as types from './types';

const initialState = {
  loading: false,
  statusText: null,
  income: {
    basicYearlyIncomeCents: 0,
    basicOtherCents: 0,

    detailedBasicCents: 0,
    detailedAllowanceCents: 0,
    detailedDeductionCents: 0,
    detailedNetCents: 0,
  },
};

export default createReducer(initialState, {
  [types.INCOME_FORM_SET]: (state, payload) => (
    Object.assign({}, state, {
      income: Object.assign({
        basicYearlyIncomeCents: 0,
        basicOtherCents: 0,

        detailedBasicCents: 0,
        detailedAllowanceCents: 0,
        detailedDeductionCents: 0,
      }, payload.income),
    })
  ),
  [types.INCOME_FORM_SET_KEY]: (state, payload) => (
    Object.assign({}, state, {
      income: Object.assign(state.income, {
        [payload.key]: payload.value,
      }),
    })
  ),
  [types.INCOME_FORM_RESET]: () => (
    Object.assign({}, initialState)
  ),
});



// WEBPACK FOOTER //
// ./src/redux/incomeForm/reducers.js